export const getGroupWidth = (
  groupWidth: number,
  groupWidthPercentage: number,
  containerWidth: number
): number => {
  if (groupWidth) {
    return groupWidth
  }
  if (groupWidthPercentage && containerWidth) {
    return containerWidth * (groupWidthPercentage * 0.01)
  }
  return undefined
}

export const additionalSubColumns = (
  tableColumns: any,
  isByExpensesTabSelected: boolean,
  isExpandedBlobsColumn: boolean,
  isExpandedProductPagesColumn: boolean,
  isExpandedPostersColumn: boolean,
  isExpandedInteractionsColumn: boolean,
  isExpandedWatchTimeColumn: boolean
  ) => {
    

  return tableColumns.map(col => {
    const label = col.label

    if (isByExpensesTabSelected) {
    switch(label){
      case 'Blobs': return {...col, subHeader: isExpandedBlobsColumn ? 'Trigger,Attach,Detach,Total' : '' } 
      case 'Product pages': return {...col, subHeader: isExpandedProductPagesColumn ? 'Trigger,Cart,Total' : '' }
      case 'Posters': return {...col, subHeader: isExpandedPostersColumn ? 'Trigger,Per Sec,Total' : '' }
      default: return col
      // case 'Product pages opened': return {...col, subHeader: 'Trigger,Cart,Total' }
      // case 'Blobs triggered': return {...col, subHeader: 'Trigger,Attach,Detach,Total' } 
      // case 'Posters clicked': return {...col, subHeader: 'Trigger,Per Sec,Total' }
    }
  }
  
  switch(label) {
    case 'Total watch time': return {
      ...col, subHeader: isExpandedWatchTimeColumn ? 'Watch time, VOV Watch time, Total' : '' 
    } 
    case 'Total interaction time': return {
      ...col, subHeader: isExpandedInteractionsColumn ? 'Main video CTA,Interaction time, VOV interaction, Total' : '' 
    } 
  }
    return col
  })

}